import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Admin/Sidebar';
import AdminSchedule from '../../components/Admin/AdminSchedule';
import useStudentsStore from '../../stores/studentsStore';
import AdminBottomNavBar from '../../components/Admin/AdminBottomNavBar';

function AdminUserSchedule() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { students, fetchStudents } = useStudentsStore();
  const [student, setStudent] = useState(null);

  useEffect(() => {
    fetchStudents();
  }, []);

  useEffect(() => {
    if (students.length > 0) {
      const foundStudent = students.find(s => s._id === id);
      setStudent(foundStudent);
    }
  }, [students, id]);

  return (
    <div className='AdminUserSchedule'>
      <div className="AdminUserSchedule__container">
        <Sidebar className="admin-sidebar" />
        <div className="content_admin admin-user-schedule-wrapper">
          <button className="admin-user-back-btn" onClick={() => navigate(-1)}>Назад</button>
          <h2 className="admin-user-title">
            Индивидуальное расписание пользователя: {student?.fullName}
          </h2>
          {student && (
            <AdminSchedule 
              studentId={id}
              // groupId не передаём, чтобы показать ВСЕ групповые участия ученика,
              // а не только одну группу из старого поля
            />
          )}
        </div>
      </div>
      <AdminBottomNavBar />
    </div>
  );
}

export default AdminUserSchedule; 